const Rept = () => import(/* webpackChunkName: "manager" */ './index');

export default {
  routes: [
    {
      path: '/papr/rept/index',
      name: 'papr_rept_index',
      component: Rept
    }
  ]
}
